import { type ComponentProps } from 'react';

import { cn } from '@/util/utils';

/**
 * The design's loading spinner: a 16px ring in the current colour with a transparent
 * quarter, one turn per --duration-spin. Lives inside a loading Button, or stands alone
 * with an accessible label.
 */
function Spinner({ className, ...props }: ComponentProps<'span'>) {
    return (
        <span
            role="status"
            aria-label="Loading"
            className={cn(
                'inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent duration-(--duration-spin)',
                className,
            )}
            {...props}
        />
    );
}

export { Spinner };
